module.exports = __webpack_public_path__ + "img/lg_ring_r_o_0_0.469e8855.png";